import { clickOutside } from '@/shared/helpers/helpers';

class LanguageSwitcher {
	triggerSelector = '.language-switcher__trigger';

	constructor(element) {
		this.element = element;
		if (!this.element) return;

		this.init();
	}

	init() {
		this.trigger = this.element.querySelector(this.triggerSelector);

		if (!this.trigger) return;

		this.bindEvents();
	}

	close() {
		this.element.classList.remove('is-open');
		this.trigger.setAttribute('aria-expanded', 'false');
	}

	onTriggerClick(event) {
		event.stopPropagation();
		const isOpen = this.element.classList.toggle('is-open');
		this.trigger.setAttribute('aria-expanded', String(isOpen));
	}

	onDocumentClick(event) {
		if (!this.element.classList.contains('is-open')) return;
		if (clickOutside(event, this.element)) this.close();
	}

	bindEvents() {
		this.onTriggerClick = this.onTriggerClick.bind(this);
		this.onDocumentClick = this.onDocumentClick.bind(this);
		this.trigger.addEventListener('click', this.onTriggerClick);
		document.addEventListener('click', this.onDocumentClick);
	}
}

export function initLanguageSwitcher() {
	document
		.querySelectorAll('.js-language-switcher')
		.forEach((element) => new LanguageSwitcher(element));
}
